module.exports = __webpack_public_path__ + "static/media/Sound_16368.5e6bc322.mp3";